module.exports = __webpack_public_path__ + "img/category-struktural.6b440518.svg";